<template>
  <div class="service-table">
    <div
      class="service-table__head"
      v-bind:class="{ search: shownSearchColumns, 'no-edit': !hasEdit }"
    >
      <div class="service-table__cell service-table__cell--checkbox" v-if="hasEdit">
        <v-checkbox
          class="service-table__cell__help checkbox-all-service"
          hide-details="false"
          aria-label="Выбрать\удалить все услуги"
          v-on:click="onClickSelectedAllToggle"
        />
      </div>
      <div class="service-table__cell">
        <span class="service-table__cell__help">
          Код клиники
          <help-icon v-bind:tooltip-text="clueClinicCode" />
        </span>
      </div>
      <div class="service-table__cell">
        <span class="service-table__cell__help">
          Код номенклатуры
          <help-icon v-bind:tooltip-text="clueCode" />
        </span>
      </div>
      <div class="service-table__cell">Наименование</div>
      <div v-if="shownSearchColumns" class="service-table__cell">Категория</div>
      <div v-if="shownSearchColumns" class="service-table__cell">Прайс</div>
      <div class="service-table__cell">Стоимость, Р</div>
      <div class="service-table__cell" v-if="hasEdit" />
      <div class="service-table__cell" v-if="hasEdit" />
      <div class="service-table__cell" v-if="hasCreate" />
      <div class="service-table__cell" v-if="hasEdit" />
      <div class="service-table__cell" v-if="hasDelete" />
    </div>
    <div class="service-table__body-mobile">
      <button
        class="service-table__body-mobile__row"
        v-bind:class="{ search: shownSearchColumns, 'no-edit': !hasEdit }"
        type="button"
        v-for="{
          id,
          code,
          name,
          price,
          categoryName,
          priceListName,
          isFavorite,
          isHidden,
          clinicCode,
        } in serviceList"
        v-bind:key="id"
        v-on:click="dispatchView(id)"
      >
        <dd class="service-table__body-mobile__row__name">{{ clinicCode }}</dd>
        <dd class="service-table__body-mobile__row__name">{{ code }}</dd>
        <dd class="service-table__body-mobile__row__name">{{ name }}</dd>
        <dt v-if="shownSearchColumns">Категория</dt>
        <dd v-if="shownSearchColumns">{{ categoryName }}</dd>
        <dt v-if="shownSearchColumns">Прайс</dt>
        <dd v-if="shownSearchColumns">{{ priceListName }}</dd>
        <dt>Стоимость</dt>
        <dd>{{ price }} руб</dd>
        <div class="service-table__body-mobile__row__actions">
          <v-switch
            title="Выводить в прайсе"
            @click.stop="dispatchToggleHidden(id)"
            v-bind:input-value="!isHidden"
            inset
            hide-details />
          <button
            type="button"
            title="Добавить в избранное"
            class="service-table__icon-favorite"
            v-bind:class="{ favorite: isFavorite }"
            v-on:click.stop="dispatchToggleFavorite(id)"
          />
          <button
            type="button"
            title="Дублировать"
            class="service-table__icon-copy"
            v-on:click.stop="dispatchCopy(id)"
          />
        </div>
      </button>
    </div>
    <div class="service-table__body">
      <div
        class="service-table__row"
        v-bind:class="{ search: shownSearchColumns, 'no-edit': !hasEdit }"
        v-for="service in serviceList"
        v-bind:key="service.id"
        v-bind:draggable="!isFocused"
        v-bind:data-service-id="service.id"
        v-on:dragenter="onDragServiceItem"
        v-on:dragend="onDropServiceItem"
        v-on:dragstart="onStartDragServiceItem"
        v-on:focusin="focusedEnabled"
        v-on:focusout="focusedDisabled"
      >
        <div
          v-if="hasEdit"
          class="service-table__cell service-table__cell__checkbox">
          <div class="cell-checkbox">
            <v-checkbox
              v-model="selectedService[service.id]"
              v-on:click="onClickCheckbox(service.id)"
            />
          </div>
        </div>
        <div
          class="service-table__cell service-table__cell__name"
        >
          <input-text
            title=""
            v-bind:allowed-null="true"
            v-bind:without-native-controls="true"
            v-bind:value="service.clinicCode"
            v-bind:maxlength="10"
            v-on:blur="onUpdateClinicCode(service.id, $event)"
          />
        </div>
        <div
          class="service-table__cell service-table__cell__name"
          data-label="Код номенклатуры"
        >
          <input-text
            title=""
            v-bind:value="service.code"
            v-on:blur="onUpdateCode(service.id, $event)"
          />
        </div>
        <div data-label="Наименование" class="service-table__cell service-table__cell__name">
          <v-textarea
            class="service-table__input"
            v-bind:value="service.name"
            v-bind:readonly="!hasEdit"
            v-on:change="onUpdateName(service.id, $event)"
            no-resize
            rows="1"
            auto-grow
            hide-details
          />
        </div>
        <div v-if="shownSearchColumns" class="service-table__cell" data-label="Категория">
          {{ service.categoryName }}
        </div>
        <div v-if="shownSearchColumns" class="service-table__cell" data-label="Прайс">
          {{ service.priceListName }}
        </div>
        <div id="price-list-button-price-edit-parent" data-label="Стоимость, Р" class="service-table__cell">
          <price-input
            class="service-table__unit"
            v-bind:value="parseFloat(service.price) * 100"
            v-on:blur="onUpdatePrice(service.id, $event)"
            v-bind:disabled="!hasEdit"
            without-kopeck
          />
        </div>
        <div class="service-table__cell" data-label="Видимость" v-if="hasEdit">
          <v-switch
            title="Выводить в прайсе"
            @click.stop="dispatchToggleHidden(service.id)"
            v-bind:input-value="!service.isHidden"
            inset
            hide-details />
        </div>
        <div class="service-table__cell" data-label="Избранное" v-if="hasEdit">
          <button
            type="button"
            title="Добавить в услуги для записи"
            class="service-table__icon-favorite"
            v-bind:class="{ favorite: service.isFavorite }"
            v-on:click.stop="dispatchToggleFavorite(service.id)"
          />
        </div>
        <div class="service-table__cell" data-label="Редактировать" v-if="hasEdit">
          <button
            type="button"
            title="Редактировать"
            class="service-table__icon-edit"
            v-on:click="dispatchView(service.id)"
          />
        </div>
        <div class="service-table__cell" data-label="Удалить" v-if="hasDelete">
          <button
            type="button"
            title="Удалить"
            class="service-table__icon-delete"
            v-on:click="dispatchDelete(service.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EditServiceRequest } from '@/storage/gateways/ServiceGateway';
import PriceInput from '@/components/PriceInput.vue';
import InputText from '@/components/InputText.vue';
import HelpIcon from '@/components/HelpIcon.vue';

/**
 * Меняем порядок услуг
 *
 * @type {string}
 */
const CHANGE_CATEGORY_ORDER = 'change-order-service';

/**
 * @description Максимальное количество попыток в рекурсии.
 * @type {number}
 */
const MAX_ATTEMPTS_IN_RECURSION = 10;

/**
 * @description Название события копирования услуги.
 * @type {string}
 */
const NAME_EVENT_COPY = 'copy';

/**
 * @description Название события удаления услуги.
 * @type {string}
 */
const NAME_EVENT_DELETE = 'delete';

/**
 * @description Название события редактирования услуги.
 * @type {string}
 */
const NAME_EVENT_EDIT = 'edit';

/**
 * @description Название события переключения избранного.
 * @type {string}
 */
const NAME_EVENT_TOGGLE_FAVORITE = 'toggle-favorite';

const NAME_EVENT_DELETE_SELECTED_SERVICE = 'remove-selected-service';

const NAME_EVENT_ADD_SELECTED_SERVICE = 'add-selected-service';

/**
 * @description Название события переключения видимости.
 * @type {string}
 */
const NAME_EVENT_TOGGLE_HIDDEN = 'toggle-hidden';

/**
 * @description Название события просмотра услуги.
 * @type {string}
 */
const NAME_EVENT_VIEW = 'view';

/**
 * @description Таблица услуг.
 * @type {any}
 */
export default {
  components: {
    HelpIcon,
    InputText,
    PriceInput,
  },
  computed: {
    /**
     * @description Имеет право создавать услуги.
     * @returns {boolean}
     */
    hasCreate() {
      return this.actions.includes('add');
    },
    /**
     * @description Имеет право удалять услуги.
     * @returns {boolean}
     */
    hasDelete() {
      return this.actions.includes('delete');
    },
    /**
     * @description Имеет право редактировать услуги.
     * @returns {boolean}
     */
    hasEdit() {
      return this.actions.includes('edit');
    },
  },
  data() {
    return {
      /**
       * @description Имеется ли фокусировка
       * @type {Boolean}
       */
      isFocused: false,
      /**
       * @description Выбранный элемент методом Drag and drop.
       * @type {HTMLElement|null}
       */
      selectedElementByDrag: null,
      /**
       * @description Подсказка для колонки "код клиники".
       * @type {String}
       */
      clueClinicCode: 'Внутренний код клиники. Не обязательно к заполнению',
      /**
       * @description Подсказка для колонки "код номенклатуры".
       * @type {String}
       */
      clueCode: 'Перечень кодов и наименований медицинских услуг, утвержденный приказом Минздрава №804н',
      /**
       * @description Выбранные Id услуг.
       * @type Array<Number>
       */
      selectedService: [],
      /**
       * @description Выбраны ли все сервисы.
       * @type {Bool}
       */
      isSelectedAllService: true,
    };
  },
  methods: {
    /**
     * @description Обработать старт перетаскивания элемента.
     * @param event
     */
    onStartDragServiceItem(event) {
      this.selectedElementByDrag = this.getServiceItemRow(event.target);
    },
    /**
     * @description Обработать события при определении нового места для выбранного категории.
     * @param {Event} event
     * @return {void}
     */
    onDropServiceItem(event) {
      const targetRow = this.defineServiceRow(event);
      if (!targetRow || !this.selectedElementByDrag) {
        return;
      }
      const selectedCategoryId = this.selectedElementByDrag.getAttribute('data-service-id');
      const enteredCategoryId = targetRow.getAttribute('data-service-id');
      if (!selectedCategoryId || !enteredCategoryId) {
        return;
      }
      this.$emit(CHANGE_CATEGORY_ORDER, {
        selectedElementId: selectedCategoryId,
        enteredElementId: enteredCategoryId,
      });
      targetRow.classList.remove('service-item__drag-selected-element');
    },
    /**
     * Обработать события начала перетаскивания элемента услуги.
     *
     * @param {event} event
     */
    onDragServiceItem(event) {
      this.disableDragSelectedStyle();
      this.dispatchSetDragSelectElement(event);
    },
    /**
     * @description Отключить стили для прежде наведенных элементов
     *
     * @return {void}
     */
    disableDragSelectedStyle() {
      document.querySelectorAll('.service-item__drag-selected-element')
        .forEach((el) => {
          el.classList.remove('service-item__drag-selected-element');
        });
    },
    /**
     * @description Отправить событие вставить элемент на который навились методом drag.
     * @param {event} event Элемент categoryItem.
     * @returns {void}
     */
    dispatchSetDragSelectElement(event) {
      const row = this.defineServiceRow(event);
      if (!row) {
        return;
      }
      row.classList.add('service-item__drag-selected-element');
    },
    /**
     * @description Определить строку услуги.
     *
     * @param {Event} event
     *
     * @returns {HTMLElement|null}
     */
    defineServiceRow(event) {
      const { clientX, clientY } = event;
      const element = document.elementFromPoint(clientX, clientY);
      return this.getServiceItemRow(element, 0);
    },

    /**
     * @description Получить строку услуги по элементу.
     * @param {HTMLElement} element
     * @param {number} attempts
     * @returns {HTMLElement|null}
     */
    getServiceItemRow(element, attempts) {
      if (attempts >= MAX_ATTEMPTS_IN_RECURSION || !element) {
        return null;
      }
      if (!element.classList.contains('service-table__row')) {
        return this.getServiceItemRow(element.parentElement, attempts + 1);
      }
      return element;
    },

    onClickCheckbox(id) {
      const isSelected = this.selectedService[id];
      if (!isSelected) {
        this.$emit(NAME_EVENT_DELETE_SELECTED_SERVICE, id);
      } else {
        this.$emit(NAME_EVENT_ADD_SELECTED_SERVICE, id);
      }
    },
    onClickSelectedAllToggle() {
      this.serviceList.forEach((item) => {
        this.selectedService[item.id] = this.isSelectedAllService;
        this.$emit(NAME_EVENT_ADD_SELECTED_SERVICE, item.id);
      });
      this.selectedService = this.selectedService.slice();
      this.isSelectedAllService = !this.isSelectedAllService;
    },
    /**
     * @description Отправить событие копирования услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchCopy(id) {
      this.$emit(NAME_EVENT_COPY, id);
    },
    /**
     * @description Отправить событие удаления услугу.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchDelete(id) {
      this.$emit(NAME_EVENT_DELETE, id);
    },
    /**
     * @description Отправить событие редактирования услуги.
     * @param {Service} service Услуга.
     * @returns {void}
     */
    dispatchEdit(service) {
      const request = new EditServiceRequest(service.id, service);
      this.$emit(NAME_EVENT_EDIT, request);
    },
    /**
     * @description Отправить событие просмотра услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchToggleFavorite(id) {
      this.$emit(NAME_EVENT_TOGGLE_FAVORITE, id);
    },
    /**
     * @description Отправить событие переключения видимости услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchToggleHidden(id) {
      this.$emit(NAME_EVENT_TOGGLE_HIDDEN, id);
    },
    /**
     * @description Отправить событие просмотра услуги.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    dispatchView(id) {
      this.$emit(NAME_EVENT_VIEW, id);
    },
    /**
     * @description Обработать обновление названия услуги.
     * @param {int}    id Идентификатор услуги
     * @param {string} newName Название услуги
     */
    onUpdateName(id, newName) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.name !== newName;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ name: newName }));
      }
    },
    /**
     * @description Обработать обновление кода клиники.
     * @param {int}    id            Идентификатор услуги.
     * @param {number} newClinicCode Код клиники.
     */
    onUpdateClinicCode(id, newClinicCode) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.clinicCode !== newClinicCode;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ clinicCode: newClinicCode }));
      }
    },
    /**
     * @description Фокусировка включена.
     * @returns {void}
     */
    focusedEnabled() {
      this.isFocused = true;
    },
    /**
     * @description Фокусировка отключена.
     * @returns {void}
     */
    focusedDisabled() {
      this.isFocused = false;
    },
    /**
     * @description Обработать обновление кода номенклатуры.
     * @param {int}    id      Идентификатор услуги.
     * @param {number} newCode Код номенклатуры.
     */
    onUpdateCode(id, newCode) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.code !== newCode;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ code: newCode }));
      }
    },
    /**
     * @description Обработать обновление цены.
     * @param {number} id       Идентификатор.
     * @param {number} newPrice Новая цена.
     * @returns {void}
     */
    onUpdatePrice(id, newPrice) {
      const service = this.serviceList.find((item) => item.id === id);
      const needUpdate = service.price * 100 !== newPrice * 100;
      if (needUpdate) {
        this.dispatchEdit(service.copyWith({ price: newPrice }));
      }
      this.focusedDisabled();
    },
  },
  name: 'ServiceTable',
  props: {
    /**
     * @description Допустимые действия.
     */
    actions: { required: true, type: Array },
    /**
     * @description Опции кодов услуг для налоговой.
     */
    serviceTaxCodeOptions: { required: true, type: Array },
    /**
     * @description Список услуг.
     */
    serviceList: { required: true, type: Array },
    /**
     * @description Отображать столбцы при поиске.
     */
    shownSearchColumns: { default: () => false, type: Boolean },
  },
};
</script>
<style lang="scss">
.service-item {
  &__drag-selected-element{
    border-image: linear-gradient(#0489e0 0%, #ffffff 2%) 1;
    border-top: 15px;
    border-style: solid;
  }
}
.cell-checkbox {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -15px 0 0 -15px;
  display: flex;
  justify-content: center;
}
.service-table {
  counter-reset: counterServices;
  flex-basis: auto;
  width: 100%;
  overflow-x: auto;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      row-gap: 5px;
      padding: 5px;
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
      &__actions {
        grid-column: 1 / 3;
        display: flex;
        align-items: center;
        gap: 15px;
        .v-input--selection-controls__input:hover,
        .v-input--selection-controls__ripple:before {
          content: none;
        }
        .v-input--selection-controls__ripple {
          display: none;
        }
        .v-input--switch .v-input--switch__track {
          background: white !important;
          border: 1px solid #c2cfe0;
          border-radius: 15px;
          opacity: 1 !important;
        }
        .v-input--switch .v-input--switch__thumb {
          color: #90a0b7;
        }
        .v-input--selection-controls {
          margin: 0 !important;
          padding: 5px !important;
        }
      }
      &__name {
        grid-column: 1 / 3;
        text-align: right;
      }
      & > dt {
        justify-self: flex-start;
      }
    }
  }
  &__head,
  &__row {
    display: grid;
    grid-template-columns: 75px 120px 150px minmax(170px, 1fr) 120px 90px 43px 100px 43px 43px;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    &.search {
      grid-template-columns: 75px 120px 150px minmax(300px, 1fr) 120px 120px 120px 90px 43px 100px 43px 43px;
    }
    &.no-edit {
      grid-template-columns: 120px 150px minmax(170px, 1fr) 120px;
    }
    &:not(.no-edit) {
      min-width: 1300px;
    }
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    padding: 5px 0;
    padding-left: 15px;
  }
  &__row {
    position: relative;
    border-bottom: 1px solid #eaeff3;
    padding: 12px 0;
    padding-left: 15px;
    cursor: grab;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 3px;
      display: none;
      width: 20px;
      height: 20px;
      mask-image: url("@/assets/img/drag-indicator.svg");
      mask-repeat: no-repeat;
      mask-position: center center;
      mask-size: contain;
      background-color: #90A0B7;
      transform: translateY(-50%);
    }
    &:hover {
      background: #eaeff3;
      &::before {
        display: block;
      }
    }
  }
  &__unit {
    width: 100%;
  }
  &__cell {
    padding: 0 8px;
    &__help {
      display: flex;
      >img {
        width: 20px;
      }
    }
    &--checkbox {
      padding-inline: 17px 8px;
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.number:after {
      counter-increment: counterServices;
      content: counter(counterServices);
    }
    &__color {
      width: 15px;
      height: 15px;
      border-radius: 50%;
    }
    &__name {
      color: var(--action-color);
    }
    &__checkbox {
      margin: 2.5px;
      width: 60px;
      height: 60px;
      position: relative;
    }
    .v-input--selection-controls__input:hover,
    .v-input--selection-controls__ripple:before {
      content: none;
    }
    .v-input--selection-controls__ripple {
      display: none;
    }
    .v-input--switch .v-input--switch__track {
      background: white !important;
      border: 1px solid #c2cfe0;
      border-radius: 15px;
      opacity: 1 !important;
    }
    .v-input--switch .v-input--switch__thumb {
      color: #90a0b7;
    }
    .v-input--selection-controls {
      margin: 0 !important;
      padding: 5px !important;
    }
  }
  &__input {
    width: 100%;
    border-bottom: 1px solid transparent;
    text-overflow: ellipsis;
    padding: 0 10px 0 0;
    &:focus {
      color: #212529;
      border-bottom: 1px solid #0489e0;
      outline: 0;
    }
  }
  &__icon {
    &-favorite {
      display: block;
      background-image: url("@/assets/img/star-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/star-blue.svg");
      }
      &.favorite {
        background-image: url("@/assets/img/star-blue.svg");
        &:hover {
          background-image: url("@/assets/img/star-grey.svg");
        }
      }
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
  &__code {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--input-border-radius);
    border: 1px solid var(--border-color);
    height: 2.5rem;
    width: 100%;
  }
}
@media screen and (max-width: 1400px) {
  .service-table {
    &__head,
    &__row {
      grid-template-columns: 55px 120px 150px minmax(150px, 1fr) 120px 90px 43px 80px 43px;
      &.search {
        grid-template-columns: 55px 120px 150px minmax(150px, 1fr) 120px 120px 120px 90px 43px 80px 43px;
      }
      &.no-edit {
        grid-template-columns: 120px 150px 1fr 110px;
      }
    }
  }
}
@media screen and (max-width: 1190px) {
  .service-table {
    &__head {
      padding: 10px 0;
    }
  }
}
@media screen and (max-width: 800px) {
  .service-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr !important;
      grid-gap: 10px;
      margin: 0 0 20px 0;
      padding-left: 0;
      &:not(.no-edit) {
        min-width: auto;
      }
      &::before {
        content: none
      }
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      font-size: 10px;
      padding: 0;
    }
    &__unit {
      text-align: right;
      width: auto;
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 10px;
    }
  }
}
@media screen and (max-width: 480px) {
  .service-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
